import React from 'react';
import { ButtonSecondary, Text } from '@spotify-internal/encore-web';

import { useTranslation } from 'providers/translations/TranslationProvider';
import { HomeLink } from 'components/Links';

const UnavailableMessaging = () => {
  const { t } = useTranslation();

  return (
    <>
      <Text as="h1" paddingBottom="0.75em" variant="titleMedium">
        {t('unavailable_messaging_title')}
      </Text>
      <Text as="p" variant="bodyMedium" paddingBottom="2em" data-testid="messaging-body">
        {t('unavailable_messaging_body')}
      </Text>
      <HomeLink>
        <ButtonSecondary>{t('unavailable_messaging_cta')}</ButtonSecondary>
      </HomeLink>
    </>
  );
};

export default UnavailableMessaging;
